/**
 * Pill-style filter bar: keeps an opened dropdown panel inside the page.
 *
 * Horizon's floating-panel-component only measures itself when it's set up (while the dropdown is
 * still closed), so a wide panel on a pill near the right edge (e.g. Price) could run off the page and
 * cause horizontal scrolling. When a pill's dropdown opens, this measures the panel and aligns it to
 * the pill's right edge (or left edge) if it would overflow.
 */

const PILLS_SELECTOR = '.facets--pills';
const PANEL_SELECTOR = ':scope > .facets__panel-content, :scope > .sorting-filter__options';
const ALIGN_END_CLASS = 'facets__panel--align-end';
const ALIGN_START_CLASS = 'facets__panel--align-start';

/** Space kept between the panel and the page edge, in px. */
const EDGE_GAP = 16;

/**
 * @param {HTMLDetailsElement} details
 */
function alignPanel(details) {
  const panel = details.querySelector(PANEL_SELECTOR);
  if (!(panel instanceof HTMLElement)) return;

  details.classList.remove(ALIGN_END_CLASS, ALIGN_START_CLASS);
  // Drop any offset floating-panel-component set while measuring the closed panel
  if (panel.style.left) panel.style.left = '';

  const pageWidth = document.documentElement.clientWidth;
  const rect = panel.getBoundingClientRect();

  if (rect.right > pageWidth - EDGE_GAP) {
    details.classList.add(ALIGN_END_CLASS);
  } else if (rect.left < EDGE_GAP) {
    details.classList.add(ALIGN_START_CLASS);
  }
}

document.addEventListener(
  'toggle',
  (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.open) return;
    if (!details.closest(PILLS_SELECTOR)) return;

    // Wait a frame so the panel is laid out before measuring
    requestAnimationFrame(() => alignPanel(details));
  },
  // `toggle` doesn't bubble, so listen in the capture phase
  true
);
